import BaseSettingsPage from "@settings/base/BaseSettingsPage";
import { useQuery } from "@apollo/client";
import { FETCH_USER_PROFILE } from "@company/graphql/queries/fetchUserProfile";
import { Grid2 } from "@mui/material";
import { EmailVerificationBanner } from "@auth/components/EmailVerificationBanner";

export const SettingsDashboardPage = () => {
  const { data } = useQuery(FETCH_USER_PROFILE);
  const profile = data?.userProfile;

  return (
    <BaseSettingsPage title="Dashboard">
      {/* Show verification banner if email is not verified */}
      {profile && !profile.emailVerified && (
        <Grid2 size={12} sx={{ mb: 2 }}>
          <EmailVerificationBanner userEmail={profile.email} />
        </Grid2>
      )}
    </BaseSettingsPage>
  );
};